import React, { useState } from "react";
import { PencilIcon } from "../../components/pencil-icon.tsx";

interface AppNameHeaderProps {
  name: string;
  onRename: (newName: string) => Promise<void>;
}

export function AppNameHeader({ name, onRename }: AppNameHeaderProps) {
  const [isEditing, setIsEditing] = useState(false);
  const [draft, setDraft] = useState("");

  function startEditing() {
    setDraft(name);
    setIsEditing(true);
  }

  async function commit() {
    const trimmed = draft.trim();
    setIsEditing(false);
    if (!trimmed || trimmed === name) {
      return;
    }
    await onRename(trimmed);
  }

  if (isEditing) {
    return (
      <input
        autoFocus
        value={draft}
        onChange={(event) => setDraft(event.target.value)}
        onBlur={commit}
        onKeyDown={(event) => {
          if (event.key === "Enter") {
            event.preventDefault();
            commit();
          } else if (event.key === "Escape") {
            setIsEditing(false);
          }
        }}
        className="w-full border-2 border-ink bg-canvas px-2 py-1 font-mono text-2xl font-bold uppercase tracking-[0.05em] text-ink focus:border-accent focus:outline-none"
      />
    );
  }

  return (
    <h1
      onClick={startEditing}
      title="Click to rename"
      className="group inline-flex cursor-text items-center gap-3 font-mono text-2xl font-bold uppercase tracking-[0.05em]"
    >
      {name}
      <PencilIcon className="h-4 w-4 text-muted opacity-0 transition-opacity group-hover:opacity-100" />
    </h1>
  );
}
